// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2-7mu","modalFooterButton":"ModalNotes_modalFooterButton__2N7RW"};